<template>
    <h-button
        square
        size="large"
        :type="this.type"
        :class="classes()"
        :loading="this.loading"
        :disabled="this.disabled"
        @click="onClick"
    >
        <h-icon v-if="icon" :type="icon" :size="size" :info="info"/>
        <slot>{{text}}</slot>
    </h-button>
</template>
<script>
import hButton from '../../button/index';
import hIcon from '../../icon/index';
import { useBEM } from '../../../common/utils/classnames';
let classnames = useBEM( 'hanzo-goods-action-button' );
export default {
    name: 'h-goods-action-button',
    components: {
        hButton,
        hIcon
    },
    props: {
        text: String,
        type: {
            type: String,
            default: 'warning'
        },
        primary: Boolean,
        loading: Boolean,
        disabled: Boolean,
        icon: String,
        size: String,
        info: String
    },
    methods: {
        classes( arg ) {
            return classnames( arg );
        },
        onClick( e ) {
            this.$emit( 'click', e );
        }
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
